import { Account_Info, Binary_Position } from '../../generated/mlmbox/types/account';

export interface ITeamBinarItem {
    partner: (Account_Info & Binary_Position) | null;
    setLoadBinary: Function;
    setPositionBinary: Function;
    setList?: Function;
    arrow?: boolean;
    teamQuantity: number | undefined;
}

export enum placesBinar {
    ONE = 1,
    THREE = 3,
    SEVEN = 7,
    ALL = 0,
    ACTIVE = 2,
}
